import { render } from "./ProfileStatus.vue?vue&type=template&id=020770cc&scoped=true"
import script from "./ProfileStatus.vue?vue&type=script&lang=js"
export * from "./ProfileStatus.vue?vue&type=script&lang=js"

import "./ProfileStatus.vue?vue&type=style&index=0&id=020770cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020770cc"]])

export default __exports__